import React from 'react';
import { Link } from 'react-router-dom';
import NavLinks from './NavLinks';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 md:hidden">
      <div className="fixed inset-0 bg-black/20 backdrop-blur-sm" onClick={onClose} />
      <div className="fixed right-0 top-0 bottom-0 w-64 bg-white p-6 shadow-xl">
        <div className="mb-8 flex flex-col space-y-4">
          <NavLinks className="text-gray-600 block py-2" onClick={onClose} />
        </div>
        <div className="flex flex-col space-y-4">
          <Link to="/signin" className="text-gray-600 block py-2" onClick={onClose}>
            Sign In
          </Link>
          <Link
            to="/signup"
            className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors text-center"
            onClick={onClose}
          >
            Get Started
          </Link>
        </div>
      </div>
    </div>
  );
}